export default {
    list: {
        add: 'Add an automation',
        allTab: 'All',
        bulkAction: 'Bulk Action',
        delete: 'Delete',
        deleteModal: {
            header: 'Delete automations',
            message: 'Are you sure you want to delete the selected automations?',
        },
        name: 'Name',
        noAutomations: 'No automation found.',
        pageTitle: 'Automations',
        pause: 'Pause',
        paused: 'Paused',
        pausedTab: 'Paused',
        run: 'Run',
        running: 'Running',
        runningTab: 'Running',
        wouldYouLikeToAddOne: 'Would you like to add one?',
    },
    modal: {
        activeDays: 'Active Days',
        advanced: 'Advanced',
        before: 'before',
        contactPreference: 'Contact\'s preference',
        content: 'Content',
        day: 'day | days',
        dayHeader: 'Day',
        divergingTimezones: 'The user\'s timezone differs from the account\'s timezone. Make sure to enter a time based on the account\'s timezone.',
        doNotSendAfter: 'Exclude appointments after...',
        doNotSendBefore: 'Exclude appointments before...',
        doNotSendWithMake: 'Exclude appointments with make containing...',
        email: 'Email',
        exclusions: 'Exclusions',
        general: 'General',
        hour: 'hour | hours',
        hourOfDay: 'Hour of day',
        keywords: 'Keywords',
        keywordsDetails: 'Multiple values can be specified, separated by commas. Case insensitive.',
        locale: 'Language',
        message: 'Message',
        name: 'Name',
        none: 'None',
        same: 'Same',
        sms: 'SMS',
        subject: 'Subject',
        successMessage: 'Your automation was created successfully.',
        timeDay: 'Time & Day',
        timeHeader: 'Time',
        timeOfDay: 'Time of day',
        title: 'New Automation Task',
        type: 'Type',
        updateMessage: 'Your automation was updated successfully.',
        userLinked: 'User linked',
        userLinkedHint: 'The automation will be sent from this user',
        week: 'week | weeks',
        weekHeader: 'Week',
        what: 'What',
        whatTime: 'What time?',
        when: 'When',
        whenAutomationActive: 'When is this automation active?',
        whenWillMessageBeSent: 'When will the message be sent?',
    },
};
